import { createPatchEndpoint } from '@sonar-software/sonar-http';

export type PatchJiraIntegrationRequest = {
	customerId: number;
	projectKey: string | null;
};

export const patchJiraIntegration = createPatchEndpoint<PatchJiraIntegrationRequest>('/api/v3/jira');
